export const apiToolsPath = () => "/api-tools";
export const apiToolsEditPath = (tool) => `/api-tools/${tool.id}`;
export const apiToolsNewPath = () => "/api-tools/new";
